import React from "react"
import TwoCol from "@slice/two-col"
import LargePullquote from "./large-pullquote"
import List from "./list"
//import LargeLink from "./large-link"
//import Simple from "./simple"
import Smallprint from "./smallprint"
//import Bundle from "./bundle"
import Queue from "./queue"
import StraplineImageDetail from "@slice/strapline-image-detail"
//import BroadbandPlanGrid from './broadband-plan-grid'
//import BroadbandPlanPromotion from './broadband-plan-promotion'
import LinkGroup from "./link-group"
//import TwoColumn2xPromotion from './two-col-promotions'
//import BundleSwitch from "./bundle-switch"
//import EnergySelector from './energy-selector'
//import Webform from './webform'
//import JobadderSignup from './jobadder-signup'
import JobadderListing from "./jobadder-listing"
import TaxonomyGrid from "./taxonomy-grid"
//import OutageMap from './outage-map'
import TwoColLargeTitle from "./two-col-large-title"
import Prose from "./prose"
import Banner from "./banner"
import tw, { styled } from "twin.macro"

import OfferGrid from "@slice/offer-grid"
import DualTile from "./dual-tile"
import TwoColHero from "@slice/two-column"
import Custom from "../content-slices/custom"

const ssr = {
  //paragraph__address_finder: AddressFinder,
  paragraph__two_column_promotion: TwoCol,
  paragraph__large_pullquote: LargePullquote,
  paragraph__ordered_list: List,
  //paragraph__large_link: LargeLink,
  //paragraph__simple: Simple,
  paragraph__smallprint: Smallprint,
  //paragraph__bundle_promotion: Bundle,
  paragraph__entity_queue: Queue,
  paragraph__strapline_image_detail: StraplineImageDetail,
  //paragraph__broadband_plan_grid: BroadbandPlanGrid,
  //paragraph__broadband_plan_promotion: BroadbandPlanPromotion,
  paragraph__link_group: LinkGroup,
  //paragraph__two_column_2x_promotion: TwoColumn2xPromotion,
  //paragraph__bundle_switch_promotion: BundleSwitch,
  //paragraph__energy_selector: EnergySelector,
  //paragraph__jobadder_alert_form: JobadderSignup,
  paragraph__jobadder_listing: JobadderListing,
  paragraph__taxonomy_grid: TaxonomyGrid,
  //paragraph__outage_map: OutageMap,
  paragraph__two_column_promotion_large_title: TwoColLargeTitle,
  //paragraph__webform: Webform,
  paragraph__prose: Prose,
  paragraph__banner: Banner,
  paragraph__offer_grid: OfferGrid,
  paragraph__dual_tile: DualTile,
  paragraph__two_column_hero: TwoColHero,
  paragraph__custom: Custom
}

const client = {
  /*paragraph__strapline_image_detail: React.lazy(() =>
        import('./strapline-image-detail')
    ),*/
  paragraph__webform: React.lazy(() => import("./webform")),
  paragraph__outage_map: React.lazy(() => import("./outage-map")),
  paragraph__flexible_row: React.lazy(() => import("./flexible-row/index.tsx")),
  paragraph__broadband_plan_promotion: React.lazy(
    () => import("./broadband-plan-promotion")
  ),
  paragraph__promotional_slat: React.lazy(() => import("./promotional-slat")),
  paragraph__large_link: React.lazy(() => import("./large-link")),
  paragraph__simple: React.lazy(() => import("./simple")),
  paragraph__movie: React.lazy(() => import("@slice/movie")),
  paragraph__two_column_group: React.lazy(
    () => import("@slice/two-column-group")
  ),
  //paragraph__two_column_2x_promotion: React.lazy(() => import('./two-col-promotions')),
  paragraph__two_column_2x_promotion: React.lazy(
    () => import("@slice/block-group")
  ),
  paragraph__jobadder_alert_form: React.lazy(() => import("./jobadder-signup")),
  paragraph__form_card: React.lazy(() => import("../content-slices/form-card")),
}

const Promotion = ({ type, ...props }) => {
  const isSSR = typeof window === "undefined"

  if (ssr.hasOwnProperty(type)) {
    const Component = ssr[type]

    return <Component {...props} site={process.env.GATSBY_SITE} />
  } else if (client.hasOwnProperty(type) && isSSR === false) {
    const ClientSideOnlyLazy = client[type]

    return (
      <>
        {!isSSR && (
          <React.Suspense fallback={<Loader />}>
            <ClientSideOnlyLazy {...props} site={process.env.GATSBY_SITE} />
          </React.Suspense>
        )}
      </>
    )
  }

  return <></>
}
export default Promotion

const Loader = styled.span`
  width: 48px;
  height: 48px;
  border: 5px solid #dfdfdf;
  border-bottom-color: rgba(0, 66, 130, var(--tw-bg-opacity));
  border-radius: 50%;
  display: inline-block;
  ${tw`animate-spin my-10 relative [left:calc(50% - 24px)]`}
`
